import React from 'react';
import { observer } from 'mobx-react';
import HeaderComponent from './Header.component';
import useHeader from './useHeader';

const Container: React.FC = () => {
    const { user, app, lang, devices, state, handlers } = useHeader();
    
    return (
        <>
            <HeaderComponent
                page={app.page}
                desktopMode={state.desktopMode}
                settingsVisible={state.settingsVisible}
                statisticsVisible={state.statisticsVisible}
                mainMenuVisible={state.mainMenuVisible}
                techSupportVisible={state.techSupportVisible}
                loginOldDevicesVisible={state.loginOldDevicesVisible} /////////////////////////////////////
                AddOldDeviceCloseVisible={app.isOpenModalAddOldDevice} ///////
                ExistOldLoginVisible={user.loginActive} //открытие формы логина
                modeSwitch={state.modeSwitch}
                userType={user.type}
                importOldVisible={user.loginOldActivated}
                lang={lang.lang}
                isDevices={!!devices.deviceList.length}
                onPrivacyPolicy={handlers.handlePrivacyPolicy}
                onLogOut={handlers.handleLogOut}
                onTechSupportClose={handlers.handleTechSupportClose}
                onTechSupportOpen={handlers.handleTechSupportOpen}
                onSettingsOpen={handlers.handleSettingsOpen}
                onSettingsClose={handlers.handleSettingsClose}
                onStatisticsOpen={handlers.handleStatisticsOpen}
                onStatisticsClose={handlers.handleStatisticsClose}
                onMainMenuBtnClick={handlers.handleMainMenuBtnClick}
                onPageChange={handlers.handlePageChange}
                onKeyDown={handlers.handleKeyDown}
                onTabClick={handlers.handleTabClick}

                onLoginOldDevicesClose = {handlers.handleLoginOldDevicesClose}  /////////////////
                onLoginOldDevicesOpen = {handlers.handleLoginOldDevicesOpen} /////////////////////////

                onAddOldDeviceClose = {handlers.handleAddOldDeviceClose}
                onAddOldDeviceOpen = {handlers.handleAddOldDeviceOpen}

                onExistOldLoginClose={handlers.handleExistOldLoginClose}
                onExistOldLoginOpen={handlers.handleExistOldLoginClose}
            />
        </>
    );
};

const HeaderContainer = observer(Container);

export default HeaderContainer;
